<template>
  <div id="works">
    <h1>JOURNEY THROUGH THE PAST - VIEWS OF THE COASTLOINE; THE MOUNTAIN RANGE AND THE INLAND SCENERY</h1>
    <div class="wrapper">
      <div class="thumb-box">
        <router-link :to="{ name: 'Peintures' }">
          <div
            class="first thumb slide-left-fade-in"
            @mouseenter="showFirstOverlay = 'in'"
            @mouseleave="showFirstOverlay = 'out'"
          >
            <div
              class="thumb-overlay"
              :class="[showFirstOverlay === 'in' ? 'thumb-fade-in' : showFirstOverlay === 'out' ? 'thumb-fade-out' : '']"
            >peintures</div>
          </div>
        </router-link>
      </div>
      <div class="thumb-box fade-in">
        <p>WORKS peintures contient une sélection de peintures, des extraits de catalogues, des articles de presse se rapportant aux expositions et des textes de critiques d’art</p>
      </div>
    </div>
    <div class="wrapper">
      <div class="thumb-box fade-in reverse-order">
        <p>WORKS installations contient une sélection de projets d’installations réalisés au cours des années.</p>
      </div>
      <div class="thumb-box">
        <router-link :to="{ name: 'Installations' }">
          <div
            class="second thumb slide-right-fade-in"
            @mouseenter="showSecondOverlay = 'in'"
            @mouseleave="showSecondOverlay = 'out'"
          >
            <div
              class="thumb-overlay"
              :class="[showSecondOverlay === 'in' ? 'thumb-fade-in' : showSecondOverlay === 'out' ? 'thumb-fade-out' : '']"
            >installations</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Works',
  data () {
    return {
      showFirstOverlay: '',
      showSecondOverlay: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.thumb-fade-in {
  animation: thumb-fade-in ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
.thumb-fade-out {
  animation: thumb-fade-out ease 0.5s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
}
.fade-in {
  animation: fade-in ease 3s;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  opacity: 0;
}
.slide-left-fade-in {
  animation: slide-left-fade-in ease 1.5s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
  animation-fill-mode: forwards;
  opacity: 0;
}
.slide-right-fade-in {
  animation: slide-right-fade-in ease 1.5s;
  animation-iteration-count: 1;
  transform-origin: 50% 50%;
  animation-fill-mode: forwards;
  opacity: 0;
}
@keyframes thumb-fade-in {
  0% {
    color: transparent;
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
  }
}
@keyframes thumb-fade-out {
  0% {
    color: white;
    background-color: rgba(0, 0, 0, 0.7);
  }
  100% {
    color: transparent;
    background-color: rgba(0, 0, 0, 0);
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes slide-left-fade-in {
  0% {
    opacity: 0;
    transform: translate(-100px, 0px);
  }
  100% {
    opacity: 1;
    transform: translate(0px, 0px);
  }
}
@keyframes slide-right-fade-in {
  0% {
    opacity: 0;
    transform: translate(100px, 0px);
  }
  100% {
    opacity: 1;
    transform: translate(0px, 0px);
  }
}
#works {
  .wrapper {
    display: flex;
    flex-flow: row;
    margin-bottom: 130px;
    margin-top: 50px;
    .thumb-box {
      position: relative;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        padding: 0 100px;
      }
      .thumb-overlay {
        position: absolute;
        display: none;
        color: transparent;
        background-color: rgba(0, 0, 0, 0);
        width: 300px;
        height: 300px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.7rem;
      }
      .thumb {
        cursor: pointer;
        width: 300px;
        height: 300px;
        border-radius: 100%;
        // overflow: hidden;
        &.first {
          background-image: url("../assets/img/works_peintures.jpg");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }
        &.second {
          background-image: url("../assets/img/works_installations.jpg");
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  #works {
    .wrapper {
      .thumb-box {
        .thumb {
          width: 200px;
          height: 200px;
        }
        p {
          padding: 0 50px;
        }
        .thumb-overlay {
          width: 200px;
          height: 200px;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  #works {
    .wrapper {
      flex-flow: column;
      .reverse-order {
        order: 2;
      }
    }
  }
}
</style>
